import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { NotifListPayload, UpdatedNotifListResponse } from './notification-setting-edition.types';

// deprecated service ref.: updateNotificationRecipientsService_DEPRECATED
export async function updateNotificationSettingsService({ body }: NotifListPayload) {
  const { response, data } = await BACKEND.put<UpdatedNotifListResponse>(ENDPOINT.NOTIFICATION_RECIPIENTS, {
    body,
  });

  return {
    response,
    summary: data,
  };
}
